module.exports = __webpack_public_path__ + "img/young-woman-avatar.357bc580.png";